export default __webpack_public_path__ + "static/media/team-3-800x800.19201574.jpg";